export const getLine = number => {
  if (number <= 6) {
    return 1
  } else if (number <= 13) {
    return 2
  } else if (number <= 20) {
    return 3
  } else if (number <= 27) {
    return 4
  } else if (number <= 31) {
    return 5
  }
}
